<script lang="ts">
  // HR Continuity view (Phase 4, spec 5.7) — "Conversations due": a plain
  // scheduling to-do list. Deliberately just name + date: no colour, no
  // reason, no OKR data — the WHY stays admin-only.
  import { createQuery } from '@tanstack/svelte-query';
  import { hrContinuityApi } from '$lib/api/hrContinuity';

  const query = createQuery(() => ({ queryKey: ['hr-continuity-conversations-due'], queryFn: () => hrContinuityApi.conversationsDue() }));

  const today = new Date().toISOString().slice(0, 10);
</script>

<div class="tym-page">
  <p class="tym-section-sub mb-4">Oldest first — for scheduling, not for why.</p>

  {#if query.isLoading}
    <div class="tym-loading-state">Loading...</div>
  {:else if query.isError}
    <div class="tym-error-state">Could not load conversations due.</div>
  {:else if query.data}
    <div class="tym-table-wrap">
      <div class="tym-table-scroll">
        <table class="tym-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Talk to them by</th>
            </tr>
          </thead>
          <tbody>
            {#each query.data as row (row.name)}
              <tr>
                <td class="font-medium text-navy">{row.name}</td>
                <td class={row.talk_to_them_by && row.talk_to_them_by < today ? 'font-medium text-red-600' : 'muted'}>
                  {row.talk_to_them_by || '—'}
                </td>
              </tr>
            {:else}
              <tr>
                <td class="empty" colspan="2">No active people.</td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
  {/if}
</div>
